import { Action, ApiState, ApiStateBase } from '../../types';

export const callService = <T, U>(
  state: ApiState<T, U>,
  updates?: Partial<U>,
  setFilter?: (f: U) => void,
  reloadFilter?: U
): ApiState<T, U> => {
  let filter = updates ? { ...state.filter, ...updates } : state.filter;
  if (reloadFilter) {
    filter = reloadFilter;
  }
  if (setFilter) {
    setFilter(filter);
  }
  return { data: state.data, filter, trigger: !state.trigger, loading: true };
};

export const serviceReducerBase = <T, U>(
  state: ApiStateBase<T>,
  action: Action<T, U>
): ApiStateBase<T> => {
  switch (action.type) {
    case 'INIT':
      return { ...state, loading: true };
    case 'SUCCESS':
      return { ...state, loading: false, data: action.payload };
    case 'FAIL':
      return { ...state, loading: false, data: null };
    default:
      return state;
  }
};

export const serviceReducer = <T, U>(
  state: ApiState<T, U>,
  action: Action<T, U>
): ApiState<T, U> => {
  switch (action.type) {
    case 'INIT':
      return { ...state, loading: true };
    case 'SUCCESS':
      return { ...state, loading: false, data: action.payload };
    case 'FAIL':
      return { ...state, loading: false, data: null };
    case 'LOADER':
      return { ...state, loading: action.value };
    case 'RELOAD':
      return callService(state, undefined, undefined, action.filter);
    default:
      return state;
  }
};
